module.exports = __webpack_public_path__ + "e8972fd93c5ccaade4f1fe1f772bd71d.svg";